import React, { useState } from "react";
import { ImportClipboard } from "./scenes/ImportClipboard";
import { ModifyData } from "./scenes/ModifyData";
import { Results } from "./scenes/Results";
import { HuntService } from "@wjossowski/tibia-calculators";
import { remove } from "ramda";

import "./App.css";

function App() {
  const [players, setPlayers] = useState(() => []);
  const [statistics, setStatistics] = useState(() => ({
    total: 0,
    profitPerPlayer: 0,
    transfers: [],
  }));
  const [scene, setScene] = useState(() => "ImportClipboard");

  const handleImportConfirmed = (clipboardText) => {
    setPlayers(
      new HuntService().parseHuntPlayers(clipboardText).map((player) => ({
        ...player,
        expenses: [],
      }))
    );
    setScene("ModifyData");
  };

  const handleAddExpense = (playerIndex) => {
    setPlayers((players) => {
      return players.map((player, index) => {
        return index === playerIndex
          ? { ...player, expenses: [...player.expenses, 0] }
          : player;
      });
    });
  };

  const handleRemoveExpense = (playerIndex, expenseIndex) => {
    setPlayers((players) => {
      return players.map((player, index) => {
        if (index === playerIndex) {
          return {
            ...player,
            expenses: remove(expenseIndex, 1, player.expenses),
          };
        }
        return player;
      });
    });
  };

  const handleUpdateExpense = (playerIndex, expenseIndex, newValue) => {
    setPlayers((players) => {
      return players.map((player, index) => {
        if (index === playerIndex) {
          return {
            ...player,
            expenses: [
              ...player.expenses.slice(0, expenseIndex),
              newValue,
              ...player.expenses.slice(expenseIndex + 1),
            ],
          };
        }
        return player;
      });
    });
  };

  const handleModificationConfirmed = () => {
    setStatistics(
      new HuntService().calculateHunt(
        players.map((player) => {
          const balance =
            player.balance -
            player.expenses.reduce((acc, expense) => (acc += expense), 0);
          return {
            name: player.name,
            balance,
          };
        })
      )
    );
    setScene("Results");
  };

  const renderScene = (scene) => {
    switch (scene) {
      case "ModifyData":
        return (
          <ModifyData
            handleAddExpense={handleAddExpense}
            handleRemoveExpense={handleRemoveExpense}
            handleUpdateExpense={handleUpdateExpense}
            handleModificationConfirmed={handleModificationConfirmed}
            handleBackButtonClicked={() => setScene("ImportClipboard")}
            players={players}
          />
        );
      case "Results":
        return (
          <Results
            handleBackButtonClicked={() => setScene("ModifyData")}
            handleResetButtonClicked={() => setScene("ImportClipboard")}
            statistics={statistics}
          />
        );
      case "ImportClipboard":
      default:
        return (
          <ImportClipboard
            handleImportConfirmed={(clipboardText) =>
              handleImportConfirmed(clipboardText)
            }
          />
        );
    }
  };

  return (
    <div className="App">
      <header className="App-header">{renderScene(scene)}</header>
    </div>
  );
}

export default App;
